import React from 'react';

import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';


import classes from "./List.css";

export default function NestedList(props) {
    let sizeClass = classes.rootSmall;
    switch (props.size) {
        case "medium":
            sizeClass = classes.rootMedium;
            break;
        case "large":
            sizeClass = classes.rootLarge;
            break;
        default:
            break;
    }

    let header = null
    if (props.header) {
        header = (<ListSubheader className={classes.header} component="div" id="nested-list-subheader">
            {props.header}
        </ListSubheader>);
    }
    return (
        <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={header}
            className={sizeClass}>
            {props.children}

        </List>
    );
}